import { useConfirmModal } from "services/modal/predefinedModals";
import { TransType } from "system/translations/types";
import { useDeleteRejectionReason } from "./apiHooks";

export const useDeleteRejectionReasonHelper = (_t: TransType) => {
  const { onConfirm } = useConfirmModal();
  const { mutate: onDelete } = useDeleteRejectionReason();

  const onDeleteWithConfirm = ({ id, allData }: any) => {
    onConfirm({
      onOk: () => onDelete({ id }),
      title: _t("are_you_sure_you_want_delete_rejection_reason_{code}_{name}", {
        code: allData?.code,
        name: allData?.name
      }),
      bodyText: _t("delete_rejection_reason_description"),
      onOkKind: "danger",
      onOkText: _t("delete"),
    });
  };

  return { onDeleteWithConfirm }
}